<div id="section">

  <div class="breadcrumb">
    <span class="breadcrumb-previous" (click)="goHome()">Home</span>
    <span> &rsaquo; </span>
    <span class="breadcrumb-current">Gestione Ristoranti e cambio turni</span>
  </div>

  <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event.index)">

    <mat-tab label="Requests to Manage">
      <ng-template matTabContent>
        <app-mdr-requests-to-manage></app-mdr-requests-to-manage>
      </ng-template>
    </mat-tab>

    <mat-tab label="Request History">
      <ng-template matTabContent>
        <app-mdr-request-history></app-mdr-request-history>
      </ng-template>
    </mat-tab>

    <mat-tab label="Restaurants">
      <ng-template matTabContent>
        <app-mdr-restaurants-tab></app-mdr-restaurants-tab>
      </ng-template>
    </mat-tab>

  </mat-tab-group>

</div>
